import React, { Fragment, useState } from "react";
import { Tab } from "@headlessui/react";
import { toast } from "react-toastify";

import {
  USER_ROLE_EMPLOYEE,
  USER_ROLE_SUPERAGENT,
  WALLET_MINIMUM_AMOUNT,
} from "../../../common/constants";
import convertNumbThousand from "../../../utils/convertNumbThousand";
import CorporateList from "../../../components/FlightBookingSteps/CorporateList";
import { currencyType } from "../../../utils/flightInfo";
import kacha from "../../../images/banks/kacha.png";
import { isCreditTimeRestricted } from "../../../services/helper";
import cbe from "../../../images/banks/cbe-bank.png";

const PaymentMethodModal = ({
  paymentMethod,
  setPaymentMethod,
  company,
  totalPrice,
  enterprise,
  booking,
  user,
  selectedCorporate,
  setSelectedCorporate,
  creditDue,
  isBefore24Hours,
  currency,
}) => {
  const [showCorporateList, setShowCorporateList] = useState(false);

  const currentDate = new Date().toLocaleDateString();
  const departureDate = new Date(
    booking?.flight?.departureTime
  ).toLocaleDateString();

  if (totalPrice < 1) {
    toast.error("Something went wrong. Please Contact Sterling Team.");
    return null;
  }

  function creditPass() {
    if (
      company &&
      company?.creditType !== "" &&
      company?.creditLimit > totalPrice &&
      currentDate !== departureDate
    ) {
      return true;
    } else {
      return false;
    }
  }

  const handleCorporateSubmit = (selectedCorporate) => {
    setShowCorporateList(false);
    setSelectedCorporate(selectedCorporate);
  };

  function USDCreditPass() {
    if (
      company &&
      company?.USDCreditType !== "" &&
      company?.USDCreditLimit > totalPrice &&
      currentDate !== departureDate
    ) {
      return true;
    } else {
      return false;
    }
  }

  const isSuper =
    user?.role === USER_ROLE_SUPERAGENT || user?.role === USER_ROLE_EMPLOYEE;

  return (
    <div className="px-4 bg-white">
      <div className="mx-2 mt-6">
        <Tab.Group>
          {currencyType(currency) === "USD" ? (
            <Tab.List className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
              {USDCreditPass() ? (
                <Tab as={Fragment}>
                  {({ selected }) => (
                    <button
                      onClick={() => {
                        setPaymentMethod("USDCredit");
                        setSelectedCorporate(null);
                      }}
                      className={`p-8 rounded-lg focus:outline-none mr-10  ${
                        paymentMethod === "USDCredit"
                          ? "bg-neutral-800 dark:bg-neutral-300 text-white dark:text-neutral-900 h-36 pt-4"
                          : "text-neutral-6000 dark:text-neutral-400 border border-gray-800 shadow-xl h-36 pt-4"
                      }`}
                    >
                      <div className="flex flex-col items-center">
                        <img
                          src="https://media.istockphoto.com/vectors/safe-payment-logo-template-designs-vector-illustration-vector-id1215256045?k=20&m=1215256045&s=612x612&w=0&h=IQX0a8uPVKSTGfJyWtWv3eXAMk4LTuQSmMtNqv_IBZs="
                          alt=""
                          className="my-2 w-20"
                        />
                        USD Credit
                      </div>
                    </button>
                  )}
                </Tab>
              ) : (
                <div className="grid-cols-6 grid-rows-4 w-full">
                  <h1 className="leading-6 text-red-600">
                    * Insufficient USD Credit Limit. Please Contact Sterling
                    team for more information.
                  </h1>
                </div>
              )}
            </Tab.List>
          ) : (
            <Tab.List className="flex flex-wrap gap-2 justify-start items-center mx-2">
              {enterprise?.method !== "postPaid" &&
                (!company ||
                  company?.wallet >
                    (company?.ADMLimit || WALLET_MINIMUM_AMOUNT) +
                      totalPrice) && (
                  <Tab as={Fragment}>
                    {({ selected }) => (
                      <button
                        onClick={() => {
                          setPaymentMethod("wallet");
                        }}
                        className={`p-4 rounded-lg focus:outline-none mr-5 w-44  ${
                          paymentMethod === "wallet"
                            ? "bg-neutral-800 dark:bg-neutral-300 text-white dark:text-neutral-900 h-36 pt-4"
                            : "text-neutral-6000 dark:text-neutral-400 border border-gray-800 shadow-xl h-36 pt-4"
                        }`}
                      >
                        <div className="flex flex-col gap-2 items-center">
                          <img
                            src="https://www.kindpng.com/picc/m/580-5809740_white-wallet-logo-png-wallet-icon-ios-transparent.png"
                            alt=""
                            className="hidden my-2 w-16 md:block"
                          />
                          Wallet
                        </div>
                      </button>
                    )}
                  </Tab>
                )}

              {(user?.role === USER_ROLE_SUPERAGENT ||
                user?.role === USER_ROLE_EMPLOYEE) && (
                <Tab as={Fragment}>
                  {({ selected }) => (
                    <button
                      onClick={() => {
                        setPaymentMethod("credit");
                        setShowCorporateList(!showCorporateList);
                      }}
                      className={`p-8 rounded-lg focus:outline-none mr-10  ${
                        paymentMethod === "credit"
                          ? "bg-neutral-800 dark:bg-neutral-300 text-white dark:text-neutral-900 h-36 pt-4"
                          : "text-neutral-6000 dark:text-neutral-400 border border-gray-800 shadow-xl h-36 pt-4"
                      }`}
                    >
                      <img
                        src="https://media.istockphoto.com/vectors/safe-payment-logo-template-designs-vector-illustration-vector-id1215256045?k=20&m=1215256045&s=612x612&w=0&h=IQX0a8uPVKSTGfJyWtWv3eXAMk4LTuQSmMtNqv_IBZs="
                        alt=""
                        className="my-2 w-20"
                        // className="hidden my-2 w-16 md:block"
                      />
                      Credit
                    </button>
                  )}
                </Tab>
              )}

              <Tab as={Fragment}>
                {({ selected }) => (
                  <button
                    onClick={() => {
                      setPaymentMethod("cbe_mobile");
                    }}
                    className={`p-4 rounded-lg focus:outline-none mr-5 w-44
             ${
               paymentMethod === "cbe_mobile"
                 ? "bg-neutral-800 dark:bg-neutral-300 text-white dark:text-neutral-900 h-36 pt-4"
                 : "text-neutral-6000 dark:text-neutral-400 border border-gray-800 shadow-xl h-36 pt-4"
             }
            `}
                  >
                    <div className="flex flex-col gap-2 items-center">
                      <img src={cbe} alt="" className="my-1 w-14" />
                      CBE Mobile Banking
                    </div>
                  </button>
                )}
              </Tab>

              <Tab as={Fragment}>
                {({ selected }) => (
                  <button
                    onClick={() => {
                      setPaymentMethod("webirr_awash");
                    }}
                    className={`p-4 rounded-lg focus:outline-none mr-5 w-44  ${
                      paymentMethod === "webirr_awash"
                        ? "bg-neutral-800 dark:bg-neutral-300 text-white dark:text-neutral-900 h-36 pt-4"
                        : "text-neutral-6000 dark:text-neutral-400 border border-gray-800 shadow-xl h-36 pt-4"
                    }`}
                  >
                    <div className="flex flex-col gap-2 items-center">
                      <img
                        src="https://play-lh.googleusercontent.com/6W3_GN3BhqJffOg3XrjStJ7ICaQWdn9DD4lid4zPA0N7O0Jz0Ifq4ymCspxaO-QwvYw"
                        alt=""
                        className="my-2 w-16"
                      />
                      Awash Bank
                    </div>
                  </button>
                )}
              </Tab>
              {/* <Tab as={Fragment}>
              {({ selected }) => (
                <button
                  onClick={() => {
                    setPaymentMethod("webirr_abyssinia");
                  }}
                  className={`p-4 rounded-lg focus:outline-none mr-5 w-44  ${
                    paymentMethod === "webirr_abyssinia"
                      ? "bg-neutral-800 dark:bg-neutral-300 text-white dark:text-neutral-900 h-36 pt-4"
                      : "text-neutral-6000 dark:text-neutral-400 border border-gray-800 shadow-xl h-36 pt-4"
                  }`}
                >
                  <div className="flex flex-col gap-2 items-center">
                    <img
                      src="https://play-lh.googleusercontent.com/9UY26ys1vxxqYPX_zL4BCBjuaCBMoXIf9yQ7RhPEqAoQJVnczlgFpWUCRem1GXzt3A"
                      alt=""
                      className="my-2 w-16"
                    />
                    Abyssinia Bank
                  </div>
                </button>
              )}
            </Tab> */}
              <Tab as={Fragment}>
                {({ selected }) => (
                  <button
                    onClick={() => {
                      setPaymentMethod("amhara");
                    }}
                    className={`p-4 rounded-lg focus:outline-none mr-5 w-44 ${
                      paymentMethod === "amhara"
                        ? "bg-neutral-800 dark:bg-neutral-300 text-white dark:text-neutral-900 h-36 pt-4"
                        : "text-neutral-6000 dark:text-neutral-400 border border-gray-800 shadow-xl h-36 pt-4"
                    }`}
                  >
                    <div className="flex flex-col gap-2 items-center">
                      <img
                        src="https://pbs.twimg.com/profile_images/1542232022726447104/dQxN5Fap_400x400.jpg"
                        alt=""
                        className="my-2 w-16"
                      />
                      Amhara Bank
                    </div>
                  </button>
                )}
              </Tab>

              {creditPass() &&
                !isSuper &&
                !isCreditTimeRestricted() &&
                !isBefore24Hours && (
                  <Tab as={Fragment}>
                    {({ selected }) => (
                      <button
                        onClick={() => {
                          setPaymentMethod("credit");
                        }}
                        // disabled={checkDueDate()}
                        className={`p-4 rounded-lg focus:outline-none mr-5 w-44  ${
                          paymentMethod === "credit"
                            ? "bg-neutral-800 dark:bg-neutral-300 text-white dark:text-neutral-900 h-36 pt-4"
                            : "text-neutral-6000 dark:text-neutral-400 border border-gray-800 shadow-xl h-36 pt-4"
                        }`}
                      >
                        <div className="flex flex-col items-center">
                          <img
                            src="https://media.istockphoto.com/vectors/safe-payment-logo-template-designs-vector-illustration-vector-id1215256045?k=20&m=1215256045&s=612x612&w=0&h=IQX0a8uPVKSTGfJyWtWv3eXAMk4LTuQSmMtNqv_IBZs="
                            alt=""
                            className="my-2 w-20"
                          />
                          Credit
                        </div>
                      </button>
                    )}
                  </Tab>
                )}
              {/* {company?.kachaCredit && ( 
                <Tab as={Fragment}>
                  {({ selected }) => (
                    <button
                      onClick={() => {
                        setPaymentMethod("kacha");
                        setSelectedCorporate(null);
                      }}
                      disabled={checkDueDate()}
                      className={`p-6 rounded-lg focus:outline-none mr-10  ${
                        paymentMethod === "kacha"
                          ? "bg-neutral-800 text-white h-36 pt-4"
                          : "text-neutral-6000 border border-gray-800 shadow-xl h-36 pt-4"
                      }`}
                    >
                      <div className="flex flex-col items-center">
                        <img src={kacha} alt="" className="mb-1 w-20" />
                        <p className="">Kacha Credit</p>
                      </div>
                    </button>
                  )}
                </Tab>
               )} */}
            </Tab.List>
          )}
        </Tab.Group>

        <div className="px-4 mt-5 text-yellow-500">
          {company &&
            paymentMethod === "wallet" &&
            company?.wallet <
              (company?.ADMLimit || WALLET_MINIMUM_AMOUNT) + totalPrice && (
              <h1 className="py-2 my-2 text-sm text-red-500 rounded-md border border-red-500">
                * You have reached your Wallet Balance please deposit to
                continue first.
              </h1>
            )}

          {!creditPass() && !isSuper && (
            <div className="py-2 my-2 text-sm text-red-500 rounded-md border border-red-500">
              {currentDate === departureDate ? (
                <span>
                  * Credit cannot be used for today's flight. Please choose an
                  alternative payment method to continue.
                </span>
              ) : (
                <span>
                  Today's sales are about to exceed your credit limit. Please
                  pay the outstanding balance and continue purchasing tickets
                  using your daily credit allowance
                </span>
              )}
            </div>
          )}
          {isBefore24Hours && (
            <div className="py-2 my-2 text-sm text-red-500 rounded-md border border-red-500">
              <h1 className="text-sm text-red-500">
                * Instant ticket issuance is recommended. If not issued
                immediately, please cancel the booking to avoid ADM charges.
              </h1>
            </div>
          )}
          {isCreditTimeRestricted() && (
            <div className="py-2 my-2 text-sm text-red-500 rounded-md border border-red-500">
              * The credit payment method is currently unavailable. It will be
              accessible after midnight. Please select an alternative payment
              method to proceed.
            </div>
          )}
        </div>

        <div className="p-4">
          <h1 className="text-xl font-medium">
            Total Price: {currency} {convertNumbThousand(totalPrice)}
          </h1>
          <h1 className="text-xl font-medium capitalize">
            Selected Payment: {paymentMethod}
          </h1>
          {selectedCorporate && (
            <h1 className="text-lg font-medium">
              Selected Corporate Name: {selectedCorporate}
            </h1>
          )}
        </div>
      </div>
      {paymentMethod === "credit" && !company && (
        <CorporateList
          show={showCorporateList}
          handleClose={handleCorporateSubmit}
          setShowCorporateList={setShowCorporateList}
        />
      )}
    </div>
  );
};

export default PaymentMethodModal;
